/**
 * U2-S1a — raccordement fiche U1 → parcours R6 (POS retail).
 * Feature flag OFF par défaut : aucune action remboursement en PREPROD sans build explicite.
 */

export function isU2S1aPosRetailFromUnifiedEnabled() {
  const env =
    typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env : {};
  return env.VITE_U2_S1A_POS_RETAIL_FROM_UNIFIED === 'true';
}

export function mapPosRetailReturnBlockReason(reason) {
  switch (reason) {
    case 'INSUFFICIENT_REFUND_PERMISSION':
      return 'Droits insuffisants pour effectuer un remboursement.';
    case 'NOTHING_REFUNDABLE':
      return 'Aucun montant ni quantité remboursable restant sur cette vente.';
    case 'NOT_RETAIL_COMPTOIR_TICKET':
      return 'Cette vente n’est pas un ticket POS retail comptoir — utilisez le parcours adapté.';
    case 'NOT_POS_ORDER':
      return 'Remboursement ticket POS réservé aux ventes comptoir.';
    case 'REFUND_MIXED_TENDERS_BLOCKED':
      return 'Paiement mixte — remboursement sécurisé indisponible depuis la caisse.';
    case 'STRIPE_USE_WEB_REFUND':
      return 'Commande Stripe — remboursement via Mes Commandes uniquement.';
    case 'WEB_SURPLACE_NOT_ENCAISSE':
      return 'Aucun encaissement magasin traçable pour cette commande.';
    default:
      return reason
        ? 'Retour POS retail indisponible pour cette vente.'
        : 'Retour POS retail indisponible.';
  }
}

/**
 * @param {object} preview — réponse GET preview U0b
 * @param {boolean} [flagEnabled] — défaut : isU2S1aPosRetailFromUnifiedEnabled()
 * @returns {{ kind: 'hidden'|'disabled_flag'|'disabled_server'|'action', ticketId?: string, message?: string }}
 */
export function resolveU2S1aPosRetailHandoff(preview, flagEnabled = isU2S1aPosRetailFromUnifiedEnabled()) {
  if (!preview?.commande?.id) {
    return { kind: 'hidden' };
  }
  const posAction = preview.allowedActions?.posRetailReturn;
  if (!posAction) {
    return { kind: 'hidden' };
  }
  if (!flagEnabled) {
    return {
      kind: 'disabled_flag',
      message:
        'Le raccordement retour POS depuis cette fiche est désactivé sur cet environnement (feature flag). Utilisez « Retour produits (retail) ».',
    };
  }
  if (preview.meta?.u2S1aUnifiedHandoffPermitted !== true) {
    return {
      kind: 'disabled_server',
      message:
        'Raccordement U1 → retour retail non activé pour cette boutique (confinement serveur). Utilisez « Retour produits (retail) ».',
    };
  }
  if (posAction.available !== true) {
    return {
      kind: 'disabled_server',
      message: mapPosRetailReturnBlockReason(posAction.reason),
    };
  }
  if (!preview.meta?.retailComptoirPos) {
    return {
      kind: 'disabled_server',
      message: mapPosRetailReturnBlockReason('NOT_RETAIL_COMPTOIR_TICKET'),
    };
  }
  const solde = Number(preview.financeSummary?.soldeRemboursable) || 0;
  if (solde <= 0) {
    return {
      kind: 'disabled_server',
      message: mapPosRetailReturnBlockReason('NOTHING_REFUNDABLE'),
    };
  }
  const hasReturnableQty = (preview.lignes || []).some(
    (l) => l.quantiteRetournable != null && Number(l.quantiteRetournable) > 0
  );
  if (!hasReturnableQty) {
    return {
      kind: 'disabled_server',
      message: mapPosRetailReturnBlockReason('NOTHING_REFUNDABLE'),
    };
  }
  return {
    kind: 'action',
    ticketId: preview.commande.id,
  };
}
